// extracted by css-extract-rspack-plugin
export default {"itemContent":"dSCNL"};